<div>
  <ul class="tabs">
    <li *ngFor="let item of items" class="mouse" (click)="onSelect(item)">
      <span class="tab-text "><h4>{{item.name}}</h4></span>
      <div [ngClass]="{'active': item.status == 'active', 'unactive': item.status == 'unactive'}" ></div>
    </li>    
  </ul>
</div>